import React, {Component} from 'react'
import {Route} from 'react-router-dom'

import Scrollbar from 'react-smooth-scroll'

// Import Common Component
import Nav from './components/common/Nav/Nav'
import Social from './components/common/Social/Social'
import Lines from './components/common/Lines'

// Import Page
import Home from './components/Pages/Home'
import About from './components/Pages/About'
import Services from './components/Pages/Services'
import Contact from './components/Pages/Contact'

// import Style
import './assets/css/style.css'


class App extends Component {


    render() {
        return (
            <Scrollbar>
                <div className="App">

                    {/* Navigation */}
                    <Nav/>

                    {/* Lines */}
                    <Lines/>

                    {/* Pages */}

                    <Route exact path="/" component={Home}/>
                    <Route exact path="/about" component={About}/>
                    <Route exact path="/services" component={Services}/>
                    <Route exact path="/contact" component={Contact}/>


                    {/* Social  */}
                    <Social/>

                </div>
            </Scrollbar>

        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js